import {useEffect, useState} from "react";

export const useIsMobile = () =>
{
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);

    useEffect(() => {
        window.addEventListener('resize', () => setIsMobile(window.innerWidth <= 500))
    }, [])

    return isMobile;
}
